const constantsDefaults = {
  "S3_DIRECT_UPLOAD_URL": undefined,
  "RAILS": {
      "STAGE": undefined,
      "SSL_ENFORCED": undefined,
      "APPLICATION_PROTOCOL": undefined,
  },
  "CC_NULL_ON_BLUR_TESTING_FIX": undefined,
  "BUCKETS": {
      "VENTURA_UPLOADS_BUCKET": undefined,
  },
  "DESTINATION": {
      "VENTURA_UPLOADS_PREFIX_DESTINATIONS": undefined,
      "THINKNEAR_HOSTED_ENDPOINT": undefined,
  },
  "LOCATION": {
      "VENTURA_UPLOADS_PREFIX_LOCATIONS": undefined,
  },
  "ATTRIBUTION_TARGET": {
      "VENTURA_UPLOADS_PREFIX_ATTRIBUTION_TARGETS": undefined,
  },
  "CLIENT": {
      "CLIENT_DRIVEN_FIELDS": undefined,
  },
  "INSERTION_ORDER": {
      "MALIBU_SITE": undefined,
      "ACCEPTED_IO_OPTIMIZATION_TYPES": undefined,
      "TARGET_STRATEGIES": undefined,
      "MEDIA_TYPES": undefined,
      "STATE_COLORS": undefined,
      "BATCH_CREATE_IO_MAX": undefined,
      "BATCH_CREATE_AD_GROUP_MAX": undefined,
      "COST_INCURRING_FEATURES": undefined,
      "THINKLAB_STATES": undefined,
      "SEED_TYPES": undefined,
      "OPTIMIZATION_TYPES": undefined,

  },
  "CONTRACT": {
      "PACING_STRATEGIES": undefined,
      "BID_SOURCE_TYPE":  [
        [ "STANDARD", "Standard" ],
        [ "PMP", "PMP" ]
      ],
      "ACCEPTED_IO_STATES": undefined,
      "ACCEPTED_CHANNELS": undefined,
      "ACCEPTED_REACHES": undefined,
      "ACCEPTED_SOURCES": undefined,
      "DISPLAY_COST_INCURRING_FEATURES": undefined,
      "BILLING_OPTIONS": undefined,
      "BILLING_TERMS_OPTIONS": undefined,
      "VERTICALS": undefined,
      "PMP_ALLOWED_EXCHANGES": undefined,
  },
  "CATEGORY": {
      "ACCEPTED_CATEGORIES": undefined,
      "ACCEPTED_SUB_CATEGORIES": undefined,
  },
  "CREATIVE": {
        "ACCEPTED_SIZES": undefined,
        "MOMENTS_ACCEPTED_SIZES": undefined,
        "SIZES": undefined,
        "AUTODETECT_SIZE": undefined,
        "ACCEPTED_AD_TYPES": undefined,
        "ALL_AD_TYPES_VALUE_TO_NAME": undefined,
        "VIDEO_AD_TYPES_VALUE_TO_NAME": undefined,
        "PMP_SUPPORTED_AD_TYPES_VALUE_TO_NAME": undefined,
        "INLINE_VIDEO_AD_TYPE": undefined,
        "WRAPPER_VIDEO_AD_TYPE": undefined,
        "MOMENT_NATIVE_AD_TYPE": undefined,
        "MOMENT_NATIVE_SURVEY_AD_TYPE": undefined,
        "NATIVE_AD_CREATIVE_SIZE": undefined,
        "SURVEY_AD_CREATIVE_SIZE": undefined,
        "ACCEPTED_PROPERTIES": undefined,
        "ACCEPTED_API_TYPES": undefined,
        "ACCEPTED_API": undefined,
        "THINKNEAR_HOSTED_PREFIX_CREATIVES": undefined,
        "THINKNEAR_HOSTED_PREFIX_NATIVE_ADS": undefined,
        "VIDEO_TRANSCODING_STATUS": undefined,
    },
    "CAMPAIGN": {
        "ACCEPTED_WHITELIST_TIERS": undefined,
        "ACCEPTED_VCR_WHITELIST_TIERS": undefined,
        "ACCEPTED_EXCHANGES": undefined,
        "ACCEPTED_BRANDSAFE_SCORES": undefined,
        "APP_OR_SITE": undefined,
        "ACCEPTED_CATEGORIES": undefined,
        "ACCEPTED_DEVICES": undefined,
        "ACCEPTED_HOURS": undefined,
        "ACCEPTED_WEATHER": undefined,
        "ACCEPTED_UV_INDEXES": undefined,
        "ACCEPTED_CARRIERS": undefined,
        "ACCEPTED_TRACKING_TYPES": undefined,
        "ACCEPTED_POLLEN_TRIGGERS": undefined,
        "ACCEPTED_GENDERS": undefined,
        "ACCEPTED_COUNTRIES": undefined,
        "ACCEPTED_REGION_STATES": undefined,
        "MAX_RECOMMENDED_BID_PRICES": undefined,
        "ACCEPTED_VIDEO_SIZES": undefined,
        "ACCEPTED_SKIPPABILITY_OPTIONS": undefined,
        "CONVERSION_TRACKING_ELIGIBLE_ENABLED": undefined,
        "ALL_ACCEPTED_TARGET_TYPES": undefined,
        "ACCEPTED_VIDEO_AD_POSITIONS": undefined,
        "DEFAULT_TARGETINGS_ENABLED_MOMENTS": undefined,
        "DEFAULT_TARGETINGS_ENABLED_NONMOMENTS": undefined,
    },
    "GEOCOOKIE": {
        "CATEGORIES": undefined,
        "MAX_CATEGORY_TARGETING": undefined,
    },
    "LIBRATO": {
        "USER": undefined,
        "TOKEN": undefined,
        "INSTRUMENT_BID_FREQUENCY": undefined,
    },
    "HONEYBADGER": undefined,
    "SEGMENT": {
        "TYPES": undefined,
        "TARGETING_DAYS": undefined,
        "TARGETING_ALL_DAYS": undefined,
    },
    "INHAND": {
        "IMAGE_BASE": undefined,
        "ENABLED": undefined,
        "CATEGORY_LIST": undefined,
        "ALCOHOL_TARGETING": undefined,
        "UPC_SENSITIVITY": undefined,
    },
}

export default constantsDefaults;
